<template>
	<div id="ixzq">
		<input type="text" v-model="w" placeholder="请输入组件宽度"/>
		<input type="text" v-model="fontSize" placeholder="请输入组件字体大小"/>
		<input type="text" v-model="unit" placeholder="请输入组件样式单位"/>
		<div class="showDiv" @click="fn(true)">{{val}}</div>
		<DataList v-model="val" :w="w" :fontSize="fontSize" :unit="unit" v-if="show" :fn="fn"/>
	</div>
</template>

<script>
import DataList from './common/calendar'
export default { 
	name:'ixzq',
	data(){
		return {
			data:[],
			val:'',
			show:false,
			w:2.57,
			fontSize:0.14,
			unit:'rem'
		}
	},
	created(){
	},
	methods:{
		fn(flag){
			this.show = flag
		}
	},
	components:{
		DataList
	},
	watch:{
		w(n,o){
			this.show = false
			setTimeout(() => {
				this.show = true
			}, 1);
		},
		fontSize(n,o){
			this.show = false
			setTimeout(() => {
				this.show = true
			}, 1);
		},
		unit(n,o){
			this.show = false
			setTimeout(() => {
				this.show = true
			}, 1);
		}
	},
	computed:{
	}
}
</script>

<style scoped>
#ixzq{
	width:100%;
	height:100%;
	background:#fff;
	display:flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}
input{
	width:200px;
	height:50px;
	padding:0 10px;
	font-size: 16px;
	color:#333;
	line-height: 50px;
	margin: 10px 0;
	background:#fff;
	border:1px solid #333;
	box-shadow: 0 0 6px rgba(0,0,0,0.3);
	border-radius: 5px;
}
.showDiv{
	width:200px;
	height:50px;
	padding:0 10px;
	font-size: 16px;
	color:#333;
	line-height: 50px;
	margin: 10px 0;
	background:#fff;
	border:1px solid #333;
	box-shadow: 0 0 6px rgba(0,0,0,0.3);
	border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue